import * as React from 'react';
import Div from '../Div';
import styles from './styles';
import { FC, useState } from 'react';
import { Typography, Modal, Grid, Button } from "@mui/material";

interface ICategoryBadgeListProps {
  list: Array<string>;
  showModalOnClick?: boolean;
}

const CategoryBadgeList: FC<ICategoryBadgeListProps> = (props) => {
  const { list, showModalOnClick = false } = props;
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    if (showModalOnClick) {
      setIsModalOpen(true);
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Div sx={styles.container}>
        {list.map((badge, index) => (
          <Typography
            key={index}
            sx={showModalOnClick ? { ...styles.badge, ...styles.clickableBadge } : styles.badge}
            onClick={handleOpenModal}
          >
            ELP {badge}
          </Typography>
        ))}
      </Div>

      <Modal open={isModalOpen} onClose={handleCloseModal} closeAfterTransition>
        <Div sx={styles.modalContainer}>
          <Typography variant="h2">English Language Proficiency</Typography>

          <Div sx={styles.tableContainer}>
            <Grid container>
              <Grid item xs={4} sx={styles.tableHeader}>
                <Typography sx={styles.headerText}>Standards</Typography>
              </Grid>
              <Grid item xs={4} sx={styles.tableHeader}>
                <Typography sx={styles.headerText}>ELP 1-3</Typography>
              </Grid>
              <Grid item xs={4} sx={styles.tableHeader}>
                <Typography sx={styles.headerText}>ELP 4-6</Typography>
              </Grid>
            </Grid>

            <Grid container>
              <Grid item xs={4} sx={styles.tableCell}>
                <Typography>California</Typography>
              </Grid>
              <Grid item xs={4} sx={styles.tableCell}>
                <Typography>Emerging</Typography>
                <Typography>Early Expanding</Typography>
              </Grid>
              <Grid item xs={4} sx={styles.tableCell}>
                <Typography>Late Expanding</Typography>
                <Typography>Bridging</Typography>
              </Grid>
            </Grid>

            <Grid container>
              <Grid item xs={4} sx={styles.tableCell}>
                <Typography>WIDA</Typography>
              </Grid>
              <Grid item xs={4} sx={styles.tableCell}>
                <Typography>1 – Entering</Typography>
                <Typography>2 – Emerging</Typography>
                <Typography>3 – Developing</Typography>
              </Grid>
              <Grid item xs={4} sx={styles.tableCell}>
                <Typography>4 – Expanding</Typography>
                <Typography>5 – Bridging</Typography>
                <Typography>6 – Reaching</Typography>
              </Grid>
            </Grid>

            <Grid container>
              <Grid item xs={4} sx={styles.tableCell}>
                <Typography>Texas</Typography>
              </Grid>
              <Grid item xs={4} sx={styles.tableCell}>
                <Typography>Beginning</Typography>
                <Typography>Intermediate</Typography>
              </Grid>
              <Grid item xs={4} sx={styles.tableCell}>
                <Typography>Advanced</Typography>
                <Typography>Advanced High</Typography>
              </Grid>
            </Grid>

            <Grid container>
              <Grid item xs={4} sx={styles.tableCell}>
                <Typography>New York</Typography>
              </Grid>
              <Grid item xs={4} sx={styles.tableCell}>
                <Typography>Entering</Typography>
                <Typography>Emerging</Typography>
                <Typography>Transitioning</Typography>
              </Grid>
              <Grid item xs={4} sx={styles.tableCell}>
                <Typography>Expanding</Typography>
                <Typography>Commanding</Typography>
              </Grid>
            </Grid>

            <Grid container>
              <Grid item xs={4} sx={styles.tableCell}>
                <Typography>TESOL</Typography>
              </Grid>
              <Grid item xs={4} sx={styles.tableCell}>
                <Typography>1 – Starting</Typography>
                <Typography>2 – Emerging</Typography>
                <Typography>3 – Developing</Typography>
              </Grid>
              <Grid item xs={4} sx={styles.tableCell}>
                <Typography>4 – Expanding</Typography>
                <Typography>5 – Bridging</Typography>
              </Grid>
            </Grid>

            <Grid container>
              <Grid item xs={4} sx={styles.tableCell}>
                <Typography>CEFR</Typography>
              </Grid>
              <Grid item xs={4} sx={styles.tableCell}>
                <Typography>A1 – Basic</Typography>
                <Typography>A2 – Basic</Typography>
                <Typography>B1 – Independent</Typography>
              </Grid>
              <Grid item xs={4} sx={styles.tableCell}>
                <Typography>B2 – Independent</Typography>
                <Typography>C1 – Proficient</Typography>
                <Typography>C2 – Proficient</Typography>
              </Grid>
            </Grid>
          </Div>

          <Div sx={styles.actionsPanel}>
            <Button onClick={handleCloseModal}>Close</Button>
          </Div>
        </Div>
      </Modal>
    </>
  );
};

export default CategoryBadgeList;
